import styled from "styled-components";

import { dateFormat } from "utils/dateUtils";

const Wrap = styled.div`
  display: flex;
  flex: 1;
  gap: 6px;
  align-items: center;
  justify-content: center;
`;

const DateArea = styled.div<{ isBold?: boolean }>`
  font-weight: normal;
  ${({ isBold }) => (isBold ? "-webkit-text-stroke: 0.6px black;" : "")}
`;

const TimeArea = styled.div<{ isBold?: boolean }>`
  font-weight: normal;
  ${({ isBold }) => (isBold ? "-webkit-text-stroke: 0.6px black;" : "")}
`;

const DateFormattedValue = ({ createdAt, isBold }: { createdAt: string; isBold?: boolean }) => {
  return (
    <Wrap>
      <DateArea isBold={isBold}>{dateFormat(createdAt, "YYYY/MM/DD")}</DateArea>
      <TimeArea isBold={isBold}>{dateFormat(createdAt, "HH:mm")}</TimeArea>
    </Wrap>
  );
};

export default DateFormattedValue;
